import React from 'react';
import { useNewUiTheme } from '../newUiTheme';
import { TextStyle, ViewStyle } from 'react-native';

export interface TextLinkLayoutProps {
  children: ListOrSingle<string>,
  onClick?: () => void,
  isThin?: boolean,
  href?: string,
  labelStyle?: TextStyle,
  style?: ViewStyle,
  className?: string,
  target?: string,
  testId?: string,
  title?: string,
  isDisabled?: boolean,
}

export interface TextLinkProps {
  children: ListOrSingle<string>;
  labelStyle?: TextStyle,
  style?: ViewStyle
  onClick?: () => void;
  isThin?: boolean,
  href?: string;
  className?: string,
  target?: string,
  testId?: string,
  title?: string,
  isDisabled?: boolean,
}

export function TextLink(props: TextLinkProps) {
  const uiTheme = useNewUiTheme();

  return (
    <uiTheme.common.TextLinkLayout
      href={props.href}
      onClick={props.onClick}
      isThin={props.isThin}
      className={props.className}
      target={props.target}
      labelStyle={props.labelStyle}
      style={props.style}
      testId={props.testId}
      title={props.title}
      isDisabled={props.isDisabled}
    >
      {props.children}
    </uiTheme.common.TextLinkLayout>
  );
}
